import ProductVariantDataHandler from 'PyzShopUi/scripts/product-detail-page/includes/productVariantData';

/**
 * Resolves SKU for a concrete product ID.
 * 1. Use provided sku if given.
 * 2. Otherwise read from variant tab DOM (.article-all-variants rows) – only contains first page when paginated.
 * 3. Otherwise read from filter data-concrete-id-to-sku (object: concreteId → sku), if present and valid.
 * 4. Otherwise read from filter data-variants (object: concreteId → { variantId }), use variantId as SKU.
 */
function resolveSkuForConcreteId(concreteId: number, sku?: string): string | undefined {
    if (sku) {
        return sku;
    }
    const productVariantData = ProductVariantDataHandler.init();
    const skuFromDom = productVariantData[concreteId]?.sku;
    if (skuFromDom) {
        return skuFromDom;
    }
    const filterEl = document.querySelector<HTMLElement>(
        '[data-spryker-product-filter="true"], [data-custom-product-filter="true"]'
    );
    if (!filterEl?.dataset) {
        return undefined;
    }
    const concreteIdToSkuJson = filterEl.dataset.concreteIdToSku;
    if (concreteIdToSkuJson) {
        try {
            const parsed = JSON.parse(concreteIdToSkuJson);
            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                const skuFromMap = parsed[String(concreteId)] ?? parsed[concreteId];
                if (skuFromMap) {
                    return skuFromMap;
                }
            }
        } catch {
            // ignore invalid JSON
        }
    }
    const variantsJson = filterEl.dataset.variants;
    if (variantsJson) {
        try {
            const variants: Record<string, { variantId?: string }> = JSON.parse(variantsJson);
            const variant = variants[String(concreteId)] ?? variants[concreteId];
            if (variant?.variantId) {
                return variant.variantId;
            }
        } catch {
            // ignore invalid JSON
        }
    }
    return undefined;
}

export const redirectToConcrete = (concreteId: number, sku?: string) => {
    const productSku = resolveSkuForConcreteId(concreteId, sku);

    if (!productSku) {
        console.error('Could not find SKU for concrete ID:', concreteId);
        return;
    }

    const currentURL = new URL(window.location.href);
    
    // Preserve existing filter_bike_id parameter (important for dropdown to work after reload)
    const existingBikeId = currentURL.searchParams.get('filter_bike_id');
    
    // Set the filter_article_number parameter
    currentURL.searchParams.set('filter_article_number', productSku);
    
    // Restore filter_bike_id if it existed (preserve bike selection)
    if (existingBikeId) {
        currentURL.searchParams.set('filter_bike_id', existingBikeId);
    }

    // since the onChange handler is called on init, without this if clause
    // we'd end in an infinity loop of reloads
    if (window.location.href !== currentURL.href) {
        // we should replace the history in the url to deal with the issue of back button on mobile browser
        history.replaceState({ path: currentURL.toString() }, document.title, currentURL.toString());
        window.location.href = currentURL.href;
    }
}
